<ng-template #content_task_request let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.tasks">
        <div class="side_popup_header">
            <span>{{ !isParentTaskNumber ? localService.languageContent.tasks.popup_title_task:
                localService.languageContent.tasks.popup_title_work_item}}</span>
            <span class="en" *ngIf="data && data.v10">&nbsp;-&nbsp;{{data.v10}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" style="padding: 10px;"
            [ngStyle]="{'max-height' : (sideBarBodyHeight + (isTaskIdAvailable ? 50 : 0))+ 'px'}" *ngIf="data">
            <div class="box" *ngIf="isTaskIdAvailable" style="margin-bottom: 10px;">
                <div class="row">
                    <div class="col-12">
                        <app-label [Text]="localService.languageContent.tasks.task_status" />
                        <span>
                            {{currentTaskStatus}}
                        </span>
                        <div class="select_option_read_only">
                            <span class="en ref_color">
                                {{data.v20}}&nbsp;
                            </span>
                            <span>{{data.v19}}</span>
                        </div>
                        <div style="text-align: right;" *ngIf="data.v5 == TaskStatus.Defined.toString()">
                            <button class=" button_link link_btn" (click)="onAction(4)">
                                <span>{{localService.languageContent.tasks.change_to_in_progress}}</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="data.v3 != userId && !isFreeze">
                    <div class="col-12">
                        <div>
                            <app-label [Text]="localService.languageContent.tasks.closing_comment" />
                        </div>
                        <div>
                            <textarea autocomplete="off" rows="4" style="margin-bottom: 10px;"
                                [id]="elementIds.closing_comment" [(ngModel)]="data.v11"
                                title="{{localService.languageContent.tasks.closing_comment}}"
                                placeholder="{{localService.languageContent.tasks.closing_comment}}">
                            </textarea>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="isFreeze">
                    <div class="col-12">
                        <div>
                            <app-label [Text]="localService.languageContent.tasks.closing_comment" />
                        </div>
                        <div>
                            {{data.v11}}
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="data.v3 != userId && !isFreeze">
                    <div class="col-6" style="text-align: center;">
                        <button type="button" class="btn btn-primary" style="width: 100%;" (click)="onAction(6)"
                            [disabled]="data.v3 == userId">
                            {{ localService.languageContent.tasks.aborted}}
                        </button>
                    </div>
                    <div class="col-6" style="text-align: center;">
                        <button type="button" class="btn btn-primary" style="width: 100%;" (click)="onAction(7)"
                            [disabled]="data.v3 == userId">
                            {{ localService.languageContent.tasks.completed}}
                        </button>
                    </div>
                </div>
            </div>
            <div class="box" *ngIf="isTaskIdAvailable" style="margin-bottom: 10px;">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <app-label [Text]="localService.languageContent.tasks.comment" />
                        </div>
                        <div>
                            <div *ngIf="isFreeze">
                                {{data.v21}}
                            </div>
                            <textarea autocomplete="off" rows="4" style="margin-bottom: 10px;" [id]="elementIds.comment"
                                [(ngModel)]="data.v21" title="{{localService.languageContent.tasks.comment}}"
                                placeholder="{{localService.languageContent.tasks.comment}}" *ngIf="!isFreeze">
                        </textarea>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="!isFreeze">
                    <div class="col-12" style="text-align: right;">
                        <button type="button" class="btn btn-primary" style="width: 100%;" (click)="onAction(5)">
                            {{ localService.languageContent.tasks.update_comment}}
                        </button>
                    </div>
                </div>
            </div>
            <div class="box" *ngIf="(!isFreeze && isTaskIdAvailable) || (isFreeze && data.v12.length > 3)"
                style="margin-bottom: 10px;">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <app-label [Text]="localService.languageContent.tasks.blocked_task" />
                            <span *ngIf="isFreeze">
                                {{data.v12}}
                            </span>
                            <input autocomplete="off" type="text" style="margin-bottom: 10px;width: 100px;"
                                [id]="elementIds.blocked_task" [(ngModel)]="data.v12" *ngIf="!isFreeze"
                                title="{{localService.languageContent.tasks.blocked_task}}"
                                placeholder="{{localService.languageContent.tasks.blocked_task}}" />
                        </div>
                        <div class="select_option_read_only" *ngIf="data.v13.length > 5">
                            <span class="en ref_color">
                                {{data.v15}}&nbsp;
                            </span>
                            <span>{{data.v14}}</span>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="!isFreeze">
                    <div class="col-6" style="text-align: center;">
                        <button type="button" class="btn btn-primary" style="width: 100%;" (click)="onAction(8)">
                            {{ localService.languageContent.tasks.add_block}}
                        </button>
                    </div>
                    <div class="col-6" style="text-align: center;">
                        <button type="button" class="btn btn-primary" style="width: 100%;" (click)="onAction(9)"
                            [disabled]="!(data.v13.length > 5)">
                            {{ localService.languageContent.tasks.unblock}}
                        </button>
                    </div>
                </div>
            </div>
            <div [ngClass]="isTaskIdAvailable ? 'box' : ''">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <app-label [Text]="localService.languageContent.tasks.title" [IsMandatory]="true" />
                        </div>
                        <div>
                            <span *ngIf="!(isParentTaskNumber && !isFreeze)" style="color: slategray;">
                                {{data.v1}}
                            </span>
                            <input autocomplete="off" type="text" style="margin-bottom: 10px;" [id]="elementIds.title"
                                [(ngModel)]="data.v1" *ngIf="isParentTaskNumber && !isFreeze"
                                title="{{localService.languageContent.tasks.title}}"
                                placeholder="{{localService.languageContent.tasks.title}}" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                            <app-label [Text]="localService.languageContent.tasks.customer_contact"
                                [IsMandatory]="false" />
                        </div>
                        <div>
                            <span *ngIf="!(isParentTaskNumber && !isFreeze)" style="color: slategray;">
                                {{data.v6}}
                            </span>
                            <input autocomplete="off" type="number" style="margin-bottom: 10px;text-align: left;"
                                [id]="elementIds.customer_contact" [(ngModel)]="data.v6"
                                *ngIf="isParentTaskNumber && !isFreeze"
                                title="{{localService.languageContent.tasks.customer_contact}}"
                                placeholder="{{localService.languageContent.tasks.customer_contact}}"
                                (keypress)="localService.isNumberOnly($event,numericConfig)" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                            <app-label [Text]="localService.languageContent.tasks.customer_detail" />
                        </div>
                        <div>
                            <div *ngIf="!(isParentTaskNumber && !isFreeze)" style="color: slategray;">
                                {{data.v8}}
                            </div>
                            <textarea autocomplete="off" rows="5" style="margin-bottom: 10px;"
                                *ngIf="isParentTaskNumber && !isFreeze" [id]="elementIds.customer_detail"
                                [(ngModel)]="data.v8" title="{{localService.languageContent.tasks.customer_detail}}"
                                placeholder="{{localService.languageContent.tasks.customer_detail}}">
                        </textarea>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="isTaskIdAvailable && isParentTaskNumber && !isFreeze">
                    <div class="col-12" style="text-align: right;">
                        <button type="button" class="btn btn-primary" (click)="onAction(3)">
                            {{localService.languageContent.common.update}}
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                            <app-label [Text]="localService.languageContent.tasks.eta" [IsMandatory]="true" />
                            <span class="en" *ngIf="isTaskIdAvailable">
                                {{data.v2 | date : 'dd-MMM'}}
                            </span>
                        </div>
                        <div *ngIf="!isTaskIdAvailable">
                            <div style="text-align: right;margin-left: 30%;">
                                <app-date-picker [isTop]="false" [selectedDate]="data.v2" [isTodayMinimumDate]="true"
                                    (selectedDateChange)="data.v2 = $event" (isOpenChange)="localService.onOpenUi(1)" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                            <app-label [Text]="localService.languageContent.tasks.task_type" [IsMandatory]="true" />
                            <span *ngIf="isTaskIdAvailable">
                                {{currentTaskType}}
                            </span>
                        </div>
                        <div *ngIf="!isTaskIdAvailable">
                            <ngx-select style="width: calc(100% - 100px);" [(ngModel)]="data.v4"
                                [optionValueField]="'key'" [optionTextField]="'value'" [items]="taskTypes"
                                [noAutoComplete]="false"
                                placeholder="{{localService.languageContent.tasks.select_task_type}}"
                                title="{{localService.languageContent.tasks.select_task_type}}">
                            </ngx-select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                            <app-label [Text]="localService.languageContent.tasks.owner" [IsMandatory]="true" />
                            <button class=" button_link link_btn" *ngIf="!isTaskIdAvailable" (click)="onAction(2)">
                                <span>{{localService.languageContent.tasks.assign_to_me}}</span>
                            </button>
                        </div>
                        <div>
                            <div class="select_option_read_only" *ngIf="isTaskIdAvailable">
                                <span class="en ref_color">
                                    {{data.v17}}&nbsp;
                                </span>
                                <span>{{data.v16}}</span>
                            </div>
                            <ngx-select *ngIf="taskOwners.length > 0 && !isTaskIdAvailable"
                                placeholder="{{localService.languageContent.tasks.select_owner}}"
                                title="{{localService.languageContent.tasks.select_owner}}" [(ngModel)]="data.v3"
                                [noAutoComplete]="false" [items]="taskOwners" [optionValueField]="'key'"
                                [optionTextField]="'selectedValueKey'">
                                <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
                                    <div title="{{option.data.key}}" class="select_option">
                                        <div>
                                            {{option.data.s_value}}
                                        </div>
                                        <div class="en ref_color">
                                            {{option.data.value}}
                                        </div>
                                    </div>
                                </ng-template>
                            </ngx-select>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="!isTaskIdAvailable">
                    <div class="col-12">
                        <div>
                            <app-label [Text]="localService.languageContent.tasks.comment" />
                        </div>
                        <div>
                            <textarea autocomplete="off" rows="5" style="margin-bottom: 10px;" [id]="elementIds.comment"
                                [(ngModel)]="data.v21" title="{{localService.languageContent.tasks.comment}}"
                                placeholder="{{localService.languageContent.tasks.comment}}">
                        </textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="side_popup_footer" *ngIf="!isTaskIdAvailable">
            <div class="row">
                <div class="col-12" style="text-align: right;">
                    <button type="button" class="btn btn-primary" (click)="onAction(1)">
                        {{localService.languageContent.common.create}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>